<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <h3>Tell us why you reject this campaign to work on more relevant pairing in the future.</h3>
          </v-card-title>
          <hr width="90%" style="margin-left: auto; margin-right: auto" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="campaign_proposed"
                    label="The campaign proposed was not relevant to me."
                    color="primary"
                    class="body-1"
                    value="The campaign proposed was not relevant to me."
                    :error="errors"
                    @change="errors = false"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="campaign_timeline"
                    label="I can't accommodate the campaign timeline."
                    color="primary"
                    value="I can't accommodate the campaign timeline."
                    :error="errors"
                    @change="errors = false"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="payout_issue" label="Payout is an issue" hint="" :error="errors" persistent-hint  @keypress="errors = false"></v-text-field>
                  <!-- <v-file-input show-size counter multiple v-model="payout_issue_file"></v-file-input> -->
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="competitor"
                    :error="errors"
                    label="I am doing a competitor brand"
                    value="I am doing a competitor brand"
                    color="primary"
                    @change="errors = false"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="not_associate"
                    :error="errors"
                    label="I do not associate with the brand."
                    value="I do not associate with the brand."
                    color="primary"
                    @change="errors = false"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Others" v-model="others" :error="errors" @keypress="errors = false" hint="" persistent-hint></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="errors">
                <v-col cols="12">
                 <v-alert type="error"> {{this.errorMessage}} </v-alert>
                </v-col>                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="cancel()" width="150"><v-icon dark left>mdi-minus-circle</v-icon> Cancel </v-btn>
            <v-btn color="error" class="ma-2" @click="reject()" width="150"><v-icon dark left>mdi-cancel</v-icon>Reject </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import pairingAPIs from '../../Pairing/pairingAPIs';
export default {
  name: 'Reject_Modal',
  props: ['dialog', 'close', 'pairingID', 'updateStatus'],
  data() {
    return {
      campaign_proposed: '',
      campaign_timeline: '',
      payout_issue: '',
      payout_issue_file: '',
      competitor: '',
      not_associate: '',
      others: '',
      errors: false,
      errorMessage: 'Pick at least one to reject.'
    };
  },
  methods: {
    clearState() {
      this.campaign_proposed = '';
      this.campaign_timeline = '';
      this.payout_issue = '';
      this.competitor = '';
      this.not_associate = '';
      this.errors = false;
      this.others = '';
    },
    validForm() {
      let valid = true;
      if (this.campaign_proposed === '' && this.campaign_timeline === '' && this.payout_issue === '' && this.competitor === '' && this.not_associate === '' && this.others === '') {
        this.errors = true;
        valid = false;
      }
      return valid;
    },
    cancel() {
      this.clearState();
      this.close();
    },
    async reject() {
      if (this.validForm()) {
        let formData = {};
        if (this.campaign_proposed) {
          formData.campaign_proposed = this.campaign_proposed
        }

        if (this.campaign_timeline) {
          formData.campaign_timeline = this.campaign_timeline
        }

        if (this.payout_issue) {
          formData.payout_issue = this.payout_issue
        }

        if (this.competitor) {
          formData.competitor = this.competitor
        }

        if (this.not_associate) {
          formData.not_associate = this.not_associate
        }

        if (this.others) {
          formData.others = this.others
        }
        // console.log('Form Data', formData);
        // console.log('Pairing ID', this.pairingID)
        await pairingAPIs.doReject(this.pairingID, {reason: formData})
        this.updateStatus('not_interested')
        this.close();
        this.clearState();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// RejectModal.vue?05640db8